// @flow

import { getEndpoint } from './crud-factory'

export async function getHCMSIntegrations(): Promise<IntegrationCPHCMS[]> {
  const integrations: Integration[] = (await getEndpoint('/integrations'))
    .integrations

  return integrations.reduce((hcmsIntegrations, integration) => {
    if (integration.type === 'CP_HCMS') {
      hcmsIntegrations.push(integration)
    }
    return hcmsIntegrations
  }, [])
}
